<template>
    <div>
        <div id='div1'>
            <!--<div style="margin-bottom: -10px;margin-top:12px;font-size: 8px">{{this.time}}</div>-->
            <div style="width: 100%;margin: auto;margin-bottom: -40px;margin-top: 20px">
                <img src="../../assets/iqeq.png" style="width: 70px" />
            </div>
            <h2 style="text-align: center">发货通知单</h2>
            <div id="headerContent">
                <span style="width:24%">ADD:{{PageHeader.Address}}</span>
                <span style="width: 24%">开单日期：{{PageHeader.Date}}</span>
                <span style="width: 25.3%">销售下单号：{{PageHeader.OrderCode}}</span>
                <span style="width:25.3%;text-align: right">发货通知单号：{{PageHeader.Code}}</span>
            </div>
            <table>
                <tr>
                    <td rowspan="3" style="border-bottom: 1px solid white;width: 10%">购货单位</td>
                    <td style="width: 12%">名称</td>
                    <td style="width: 30%">{{PageBody.AgentCompanyName}}</td>
                    <td style="width: 12%">联系人</td>
                    <td style="width: 20%">{{PageBody.ContactName}}</td>
                </tr>
                <tr>
                    <td>合同地址</td>
                    <td>{{PageBody.DefaultAgentAddress}}</td>
                    <td>手机</td>
                    <td>{{PageBody.ContactTel}}</td>
                </tr>
                <tr>
                    <td style="border-bottom: 1px solid white">发货地址</td>
                    <td colspan="3" style="border-bottom: 1px solid white">{{PageBody.AgentAddress}}</td>
                </tr>
            </table>
            <table>
                <thead>
                    <tr>
                        <th style="width: 5%;height: 40px">序号</th>
                        <th style="width: 13%">产品编号</th>
                        <th style="width:32%;overflow: hidden">产品名称</th>
                        <th style="width: 9%">数量</th>
                        <th style="width: 15%">备注</th>
                        <th style="width: 13%">拼箱箱号</th>
                        <th style="width: 13%">拼箱数量</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in PageBody.ListProduct">
                        <td>{{index+1}}</td>
                        <td>{{item.ProCode}}</td>
                        <td>{{item.ProName}}</td>
                        <td>{{item.ProNum}}</td>
                        <td>{{item.Remark}}</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colspan="7" style="text-align: left;padding-left: 30px">
                            <span style="margin-right:15px ">寄送方式：{{PageBody.SendModeName}} {{PageBody.PayModeName}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">备注</td>
                        <td colspan="5">{{PageBody.Remark}}</td>
                    </tr>
                </tbody>
                <tfoot>
    
                </tfoot>
            </table>
            <div id="FootContent">
                <span>仓库管理员：{{PageFooter.StockOutAdmin}}</span>
                <span>业务员：{{PageFooter.SaleEmpName}}</span>
                <span>开单人：{{PageFooter.AddUserName}}</span>
                <span>用户签名：</span>
            </div>
            <div style="width: 100%;margin: auto">发货单位：{{PageFooter.CompanyName}}</div>
        </div>
        <div>
            <el-row>
                <el-col :span="24" style="display: flex;justify-content: center;margin: 20px 0">
                    <el-button @click="printPage">打印</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import NProgress from 'nprogress'
import {
    ViewSendGoodsForStock, LoadDataForSendPrint, SendGoodsPrint
} from '../../api/sendGoodsApi.js'
import { StockOutPrint, LoadDataForStockOutPrint } from '../../api/stockOutApi.js'
import {
    util
} from '../../common/js/util.js';
module.exports = {
    data() {
        return {
            tabelTitle: "",
            PrintData: {},
            PageHeader: {},
            PageBody: {},
            PageFooter: {},
            time: "",
        }
    },
    methods: {
        printPage() {
            let _session = util.getSessin();
            if (this.$route.query.Goods == undefined) {
                let param = {
                    Sid: _session[0],
                    Session: _session[1],
                    SendId: this.$route.query.Id
                };
                SendGoodsPrint(param).then(res => {
                    util.doResult(this, res,
                        () => {

                        });
                })
            } else {
                let params = {
                    Sid: _session[0],
                    Session: _session[1],
                    Id: this.$route.query.Id
                };
                StockOutPrint(params).then(res => {
                    util.doResult(this, res,
                        () => {

                        });
                })
            }
            document.title = "";
            document.body.style.backgroundColor = "white";
            document.body.innerHTML = document.getElementById('div1').innerHTML;
            window.print();
            location.reload();
        }
    },
    created: function () {
        let _session = util.getSessin();
        let para = {
            Sid: _session[0],
            Session: _session[1],
            Id: this.$route.query.Id
        };
        if (this.$route.query.Goods == undefined) {
            LoadDataForSendPrint(para).then(res => {
                util.doResult(this, res,
                    () => {
                        this.PrintData = res.data.Data;
                        this.PageHeader = this.PrintData.PageHeader;
                        this.PageBody = this.PrintData.PageBody;
                        //this.PageBody={"AgentName":"测试测2222","AgentCompanyName":"测试测2222","AgentAddress":"河北省承德市双滦区55","DefaultAgentAddress":"山西省大同市矿区的点点滴滴","Consignee":"44","ConsigneeTel":"55","PayModeName":"寄付","SendModeName":"快递","Remark":"","ListProduct":[{"ProCode":"2222","ProName":"111","ProNum":1,"ProNums":"1箱","Remark":"1箱"},{"ProCode":"3633","ProName":"测试","ProNum":1,"ProNums":"1888","Remark":"2888"},{"ProCode":"325665","ProName":"测试测试","ProNum":1,"ProNums":"1箱","Remark":"3箱"},{"ProCode":"D00000002","ProName":"测试单品点评单","ProNum":1,"ProNums":"2台","Remark":"4台"},{"ProCode":"4444233","ProName":"22333","ProNum":1,"ProNums":"1箱","Remark":""},{"ProCode":"D00000002","ProName":"测试单品点评单","ProNum":1,"ProNums":"2台","Remark":"4台"},{"ProCode":"4444233","ProName":"22333","ProNum":1,"ProNums":"1箱","Remark":""},{"ProCode":"D00000002","ProName":"测试单品点评单","ProNum":1,"ProNums":"2台","Remark":"4台"},{"ProCode":"4444233","ProName":"22333","ProNum":1,"ProNums":"1箱","Remark":""},{"ProCode":"D00000002","ProName":"测试单品点评单","ProNum":1,"ProNums":"2台","Remark":"4台"},{"ProCode":"4444233","ProName":"22333","ProNum":1,"ProNums":"1箱","Remark":""},{"ProCode":"D00000002","ProName":"测试单品点评单","ProNum":1,"ProNums":"2台","Remark":"4台"},{"ProCode":"4444233","ProName":"22333","ProNum":1,"ProNums":"1箱","Remark":""},{"ProCode":"D00000002","ProName":"测试单品点评单","ProNum":1,"ProNums":"2台","Remark":"4台"},{"ProCode":"4444233","ProName":"22333","ProNum":1,"ProNums":"1箱","Remark":""},{"ProCode":"D00000002","ProName":"测试单品点评单","ProNum":1,"ProNums":"2台","Remark":"4台"},{"ProCode":"4444233","ProName":"22333","ProNum":1,"ProNums":"1箱","Remark":""},{"ProCode":"D00000002","ProName":"测试单品点评单","ProNum":1,"ProNums":"2台","Remark":"4台"},{"ProCode":"4444233","ProName":"22333","ProNum":1,"ProNums":"1箱","Remark":""},{"ProCode":"D00000002","ProName":"测试单品点评单","ProNum":1,"ProNums":"2台","Remark":"4台"},{"ProCode":"4444233","ProName":"22333","ProNum":1,"ProNums":"1箱","Remark":""},{"ProCode":"D0000004","ProName":"测试测试33","ProNum":1,"ProNums":"11","Remark":""},{"ProCode":"D000009","ProName":"单品C","ProNum":1,"ProNums":"1箱","Remark":"5箱"},{"ProCode":"111111111111111","ProName":"11111111111","ProNum":1,"ProNums":"1箱","Remark":"6箱"},{"ProCode":"00000000000","ProName":"修改0999999999","ProNum":2,"ProNums":"2辆","Remark":"7-8辆"},{"ProCode":"6666666666666","ProName":"3333333333","ProNum":1,"ProNums":"1哦哦","Remark":""},{"ProCode":"10011001","ProName":"test101","ProNum":1,"ProNums":"1个","Remark":""},{"ProCode":"测试单品005","ProName":"测试单品005","ProNum":1,"ProNums":"1件","Remark":""},{"ProCode":"单品测试006","ProName":"单品测试006","ProNum":1,"ProNums":"1箱","Remark":"9箱"},{"ProCode":"eeeeeeeeeeeeeeee","ProName":"sssss","ProNum":1,"ProNums":"1888","Remark":"10888"},{"ProCode":"单品测试0010","ProName":"单品测试0010","ProNum":1,"ProNums":"1件","Remark":""},{"ProCode":"单品测试009","ProName":"单品测试009","ProNum":2,"ProNums":"2件","Remark":""},{"ProCode":"222222222222222","ProName":"111222222222","ProNum":1,"ProNums":"1箱","Remark":"11箱"}]}
                        this.PageFooter = this.PrintData.PageFooter;
                        this.tabelTitle = "发货通知单"
                    });
            })
        } else {
            LoadDataForStockOutPrint(para).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    this.PrintData = res.data.Data;
                    this.PageHeader = this.PrintData.PageHeader;
                    this.PageBody = this.PrintData.PageBody;
                    this.PageFooter = this.PrintData.PageFooter;
                    this.tabelTitle = "发货通知单"
                }
            })
        }


    }
}
</script>
<style scoped media="print">
@page {
    size: auto;
    /* auto is the initial value */
    margin-top: 0mm;
    /* this affects the margin in the printer settings */
    margin-bottom: 0mm;
}

table {
    margin: 0 auto;
    width: 100%;
    border-collapse: collapse;
    /*关键d代d码*/
}

th,
td {
    text-align: center;
    border: 1px solid black;
}

td {
    padding: 5px 0;
}

#div1 {
    margin: 0 100px;
}

#headerContent {
    width: 100%;
    font-size: 8px;
    margin: 20px auto;
}

#headerContent span {
    width: 24.6%;
    display: inline-block;
}

#FootContent {
    width: 100%;
    font-size: 15px;
    margin: 7px auto;
}

#FootContent span {
    width: 24.5%;
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// SendGoodsPage.vue?0a2f9791